<template>
  <div class="nettdoc-summary" :style="printView ? 'margin-bottom: 100px' : ''">
    <template v-if="edit === ''">
      <h2 class="nettdoc-header nettdoc-summary__header">Anamnese <span v-if="$i18n.locale && $i18n.locale !== 'de'" style="color:var(--cool-grey)">{{ $t('Anamnesis' )}}</span></h2>
      <SectionHeader 
        name="patientInformation"
        text="Persönliche Angaben" 
        :spanText="$i18n.locale && $i18n.locale !== 'de' ? $t('Personal information') : ''"
        :collapsable="true" 
        :showCollapsable="!printView" 
        v-on:collapse="collapseSection('patientInformation')"
        :collapsed="patientInformationCollapsed"
        :dark="true"
        :big="true"
        v-on:edit="value => editSection(value)"
        :printView="printView"
      />
      <template v-if="patientInformationCollapsed">
        <div class="nettdoc-summary__entry">
          <p class="nettdoc-summary__entry--label">Geschlecht <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t('Gender') }}</span></p>
          <p class="nettdoc-summary__entry--data">{{ $t(store.patientInformation.gender, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(store.patientInformation.gender) }}</span></p>
        </div>
        
        <div class="nettdoc-summary__entry">
          <p class="nettdoc-summary__entry--label">Alter <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t('Age') }}</span></p>
          <p class="nettdoc-summary__entry--data">{{ $t(store.patientInformation.age, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(store.patientInformation.age) }}</span></p>
        </div>

        <div class="nettdoc-summary__entry">
          <p class="nettdoc-summary__entry--label">Körpergrösse in Zentimeter <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t('Height in cm') }}</span></p>
          <p class="nettdoc-summary__entry--data">{{ $t(store.patientInformation.height, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(store.patientInformation.height) }}</span></p>
        </div>

        <div class="nettdoc-summary__entry">
          <p class="nettdoc-summary__entry--label">Körpergewicht in Kilogramm <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t('Weight in kg') }}</span></p>
          <p class="nettdoc-summary__entry--data">{{ $t(store.patientInformation.weight, 'de') }} <span>{{ $t(store.patientInformation.weight) }}</span></p>
        </div>

        <div class="nettdoc-summary__entry">
          <p class="nettdoc-summary__entry--label">Seit wann sind sie in Deutschland? <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t('Since when are you in Germany?') }}</span></p>
          <p class="nettdoc-summary__entry--data">{{ $t(store.patientInformation.inGermanySince, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(store.patientInformation.inGermanySince) }}</span></p>
        </div>

        <div class="nettdoc-summary__entry">
          <p class="nettdoc-summary__entry--label">Auf welchem Weg sind sie nach Deutschland gekommen? <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t('How did you get to Germany?') }}</span></p>
          <p class="nettdoc-summary__entry--data">{{ $t(store.patientInformation.wayToGermany, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(store.patientInformation.wayToGermany) }}</span></p>
        </div>

        <div class="nettdoc-summary__entry">
          <p class="nettdoc-summary__entry--label">Wer hat die Bögen ausgefüllt? <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t('Who is filling in the sheets?') }}</span></p>
          <p class="nettdoc-summary__entry--data">{{ $t(store.user, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(store.user) }}</span></p>
        </div>
      </template>

      <SectionHeader 
        name="symptoms"
        text="Beschwerden" 
        :spanText="$i18n.locale && $i18n.locale !== 'de' ? $t('Symptoms') : ''"
        :collapsable="true" 
        :showCollapsable="!printView" 
        v-on:collapse="collapseSection('symptoms')"
        :collapsed="symptomsCollapsed"
        :dark="true"
        :big="true"
        v-on:edit="value => editSection(value)"
        :printView="printView"
      />
      <template v-if="symptomsCollapsed">
        <template v-for="(value, condition, index) in this.store.additionalConditions">
          <SectionHeader 
            v-if="condition !== 'takingMedicine' && value === 'yes'"
            :key="condition+index"
            :name="condition"
            :text="$t(condition, 'de')"
            :spanText="$i18n.locale && $i18n.locale !== 'de' ? $t(condition) : ''"
            :collapsable="condition === 'pregnancy' ? true : false"
            :showCollapsable="condition === 'pregnancy' ? true : false"
            v-on:collapse="collapseSection(condition)"
            :collapsed="currentCollapse(condition) || printView"
            :img="getImg(condition)"
            v-on:edit="val => editSection(val)"
            :printView="printView"
          />
          <template v-if="currentCollapse(condition) || printView">
            <template v-for="(conditionValue, conditionProp, index) in store[condition+'Details']">
              <div v-if="conditionValue !== null && conditionProp !== 'submitted'" class="nettdoc-summary__entry" :key="condition+conditionProp+index">
                <p class="nettdoc-summary__entry--label">{{ $t(conditionProp, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(conditionProp) }}</span></p>
                <p class="nettdoc-summary__entry--data">{{ $t(conditionValue, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(conditionValue) }}</span></p>
              </div>
            </template>
          </template>
        </template>
        
        <template v-for="(value, symptom, index) in this.store.symptoms">
          <SectionHeader 
            v-if="value === 'yes' || value === true"
            :key="symptom+index"
            :name="symptom"
            :text="$t(symptom, 'de')"
            :spanText="$i18n.locale && $i18n.locale !== 'de' ? $t(symptom) : ''"
            :collapsable="true"
            :showCollapsable="true"
            v-on:collapse="collapseSection(symptom)"
            :collapsed="currentCollapse(symptom) || printView"
            :img="getImg(symptom)"
            v-on:edit="val => editSection(val)"
            :printView="printView"
          />
          <template v-if="currentCollapse(symptom) || printView">
            <template v-for="(symptomValue, symptomProp, i) in store[symptom+'Details']">
              <template v-if="symptomValue !== null  && symptomProp !== 'submitted'">

                <div v-if="typeof store[symptomProp+'Details'] === 'object'" :key="symptom.name+symptomProp+i">

                  <template v-if="symptomValue !== null && symptomValue !== '' && symptomValue !== []">
                    <SectionHeader v-if="symptomValue === 'yes'" :name="symptomProp+'Details'" :text="$t(symptomProp+'Details', 'de')" :spanText="$i18n.locale && $i18n.locale !== 'de' ? $t(symptomProp+'Details') : ''" :collapsable="false" :printView="printView" />
                    <div class="nettdoc-summary__entry">
                      <p class="nettdoc-summary__entry--label">{{ $t(symptomProp, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(symptomProp) }}</span></p>
                      <p class="nettdoc-summary__entry--data">{{ $t(symptomValue, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(symptomValue) }}</span></p>
                    </div>
                  </template>

                  <template v-for="(symptomDetailValue, symptomDetailProp, symptomDetailIndex) in store[symptomProp+'Details']">
                    <template v-if="symptomDetailValue && symptomDetailValue !== '' && symptomDetailValue.length > 0">
                      <div v-if="symptomValue !== null && symptomValue !== 'no'" :key="symptomProp+symptomDetailProp+symptomDetailIndex" class="nettdoc-summary__entry">

                        <template v-if="symptomDetailProp.toLowerCase() === 'location' || symptomDetailProp.includes('Location')">
                          <p class="nettdoc-summary__entry--label">{{ $t(symptomDetailProp, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(symptomDetailProp) }}</span></p>
                          <Bodyparts v-if="symptomDetailValue && symptomDetailValue.length > 0" :model="symptomDetailValue" :preview="true" />
                        </template>

                        <template v-else-if="typeof symptomDetailValue === 'object' && symptomDetailValue.length > 0">
                          <p class="nettdoc-summary__entry--label">{{ $t(symptomDetailProp, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(symptomDetailProp) }}</span></p>
                          <div class="nettdoc-summary__entry--data">
                          <p v-for="(entry, index) in symptomDetailValue" :key="symptom.name+symptomDetailProp+entry+index" style="display:grid;grid-template-columns:max-content max-content max-content;grid-column-gap:5px;margin-top:5px;">
                            <img src="../assets/checkbox-check.svg" width="10px" height="10px" style="align-self:center;" />
                            {{ $t(entry, 'de') }} 
                            <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(entry) }}</span>
                          </p>
                          </div>
                        </template>
                        
                        <template  v-else-if="symptomDetailValue && symptomDetailValue !== ''">
                          <p class="nettdoc-summary__entry--label">{{ $t(symptomDetailProp, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(symptomDetailProp) }}</span></p>
                          <p class="nettdoc-summary__entry--data">{{ $t(symptomDetailValue, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(symptomDetailValue) }}</span></p>
                        </template>

                      </div>
                    </template>
                  </template>

                </div>

                <template v-else>
                  <template v-if="symptomProp.toLowerCase() === 'location' || symptomProp.includes('Location')">
                    <div v-if="symptomValue && symptomValue.length > 0" class="nettdoc-summary__entry" :key="symptom.name+symptomProp+i">
                      <p class="nettdoc-summary__entry--label">{{ $t(symptomProp, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(symptomProp) }}</span></p>
                      <Bodyparts :model="symptomValue" :preview="true" />
                    </div>

                  </template>

                  <div v-else-if="typeof symptomValue === 'object' && symptomValue.length > 0" class="nettdoc-summary__entry" :key="symptom.name+symptomProp+i">
                    <p class="nettdoc-summary__entry--label">{{ $t(symptomProp, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(symptomProp) }}</span></p>
                    <div class="nettdoc-summary__entry--data">
                    <p v-for="(entry, index) in symptomValue" :key="symptom.name+entry+index" style="display:grid;grid-template-columns:max-content max-content max-content;grid-column-gap:5px;margin-top:5px;">
                      <img src="../assets/checkbox-check.svg" width="10px" height="10px" style="align-self:center;" />
                      {{ $t(entry, 'de') }} 
                      <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(entry) }}</span>
                    </p>
                    </div>
                  </div>

                  <div v-else class="nettdoc-summary__entry" :key="symptom.name+symptomProp+i">
                    <p class="nettdoc-summary__entry--label">{{ $t(symptomProp, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(symptomProp) }}</span></p>
                    <p class="nettdoc-summary__entry--data">{{ $t(symptomValue, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(symptomValue) }}</span></p>
                  </div>

                </template>

              </template>
            </template>
          </template>
        </template>

        <div class="nettdoc-summary__entry">
          <p class="nettdoc-summary__entry--label" style="color:var(--charcoal-grey);font-weight:bold;text-transform:none;font-size:16px;">
            Wenn Sie bestimmte Medikamente einnehmen, zeigen Sie dem Arzt bitte die Medikamentenverpackung, wenn möglich.
          </p>
          <p v-if="$i18n.locale && $i18n.locale !== 'de'" class="nettdoc-summary__entry--label" style="font-weight:normal;color: var(--charcoal-grey);margin-top:10px;text-transform:none;font-size:16px;">
            {{ $t('Please show the medic the package of the medicine you are taking.') }}
          </p>
        </div>
      </template>

      <SectionHeader 
        name="medicalHistory"
        text="Vorerkrankungen" 
        :spanText="$i18n.locale && $i18n.locale !== 'de' ? $t('Medical history') : ''"
        :collapsable="true" 
        :showCollapsable="!printView" 
        v-on:collapse="collapseSection('medicalHistory')"
        :collapsed="medicalHistoryCollapsed"
        :dark="true"
        :big="true"
        v-on:edit="value => editSection(value)"
        :printView="printView"
      />
      <template v-if="medicalHistoryCollapsed">
        <template v-for="(value, prop, index) in store.medicalHistory">
          <template v-if="value !== null && typeof value !== 'object'">
            <div :key="'medicalHistory_'+prop+index" class="nettdoc-summary__entry">
              <p class="nettdoc-summary__entry--label">{{ $t(prop, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(prop) }}</span></p>
              <p class="nettdoc-summary__entry--data">{{ $t(value, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(value) }}</span></p>
            </div>
          </template>

          <template v-if="prop.toLowerCase() === 'location' || prop.includes('Location')">
            <div v-if="value && value.length > 0" :key="prop+'bodyparts'+index" class="nettdoc-summary__entry">
              <p class="nettdoc-summary__entry--label" :key="prop+'location'+index">{{ $t(prop, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(prop) }}</span></p>
              <Bodyparts :model="value" :preview="true" />
            </div>
          </template>

          <template v-else-if="value !== null && typeof value === 'object' && Object.keys(value).find(detail => store.medicalHistory[prop][detail] !== null) && prop !== 'substanceConsume'"> 
            <SectionHeader 
              :key="prop+'_'+index"
              :text="$t(prop, 'de')" 
              :spanText="$i18n.locale && $i18n.locale !== 'de' ? $t(prop) : ''"
            />
            <template v-for="(v, p, i) in store.medicalHistory[prop]">
              <div v-if="v !== null && typeof v !== 'object'" :key="prop+'_'+i+index" class="nettdoc-summary__entry" >
                <p class="nettdoc-summary__entry--label">{{ $t(p, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(p) }}</span></p>
                <p class="nettdoc-summary__entry--data">{{ $t(v, 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(v) }}</span></p>
              </div>
            </template>
          </template>
        </template>

        <div class="nettdoc-summary__entry">
          <p class="nettdoc-summary__entry--label">{{ $t('substanceConsume', 'de') }} <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t('substanceConsume') }}</span></p>
          <p v-for="(substance, index) in store.medicalHistory.substanceConsume" class="nettdoc-summary__entry--data" :key="'medicalhistory_'+substance+index" style="display:grid;grid-template-columns:max-content max-content max-content;grid-column-gap:5px;margin-top:5px;">
            <img src="../assets/checkbox-check.svg" width="10px" height="10px" style="align-self:center;" />
            {{ $t(substance, 'de') }} 
            <span v-if="$i18n.locale && $i18n.locale !== 'de'">{{ $t(substance) }}</span>
          </p>      
        </div>
      </template>

      <Button
        v-if="!printView"
        text="Save and Export"
        :active="true"
        v-on:action="saveAndExport"
      />
    </template>
    <component v-if="edit !== ''" :is="edit" :store="store" :edit="true" v-on:close="closeEdit()" />
  </div>
</template>

<script>
import { observer } from "mobx-vue";
import store from "../store/store";

import SectionHeader from '../components/SectionHeader'
import Dropdown from '../components/Dropdown'
import NumberInput from '../components/NumberInput'
import YesNo from '../components/YesNo'
import Button from '../components/Button'

import BreathingProblems from "../components/SymptomDetails/BreathingProblems";
import Pain from "../components/SymptomDetails/Pain";
import ProblemsOfDigestion from "../components/SymptomDetails/ProblemsOfDigestion";
import RaisedBodyTemperature from "../components/SymptomDetails/RaisedBodyTemperature";
import Dizziness from "../components/SymptomDetails/Dizziness";
import Pregnancy from "../components/SymptomDetails/Pregnancy";
import WeaknessOrExhaustion from "../components/SymptomDetails/WeaknessOrExhaustion";
import ParalysisDeafnessPrickle from "../components/SymptomDetails/ParalysisDeafnessPrickle";
import SensoryPerception from "../components/SymptomDetails/SensoryPerception";
import Swelling from "../components/SymptomDetails/Swelling";
import GynecologicalIssues from "../components/SymptomDetails/GynecologicalIssues";
import RashItchRedness from "../components/SymptomDetails/RashItchRedness";

import Symptoms from './Symptoms'
import PatientInformation from './PatientInformation'
import MedicalHistory from './MedicalHistory'

import SymptomLocationSideFace from '../components/SymptomLocationSideFace'
import SymptomLocationFrontFace from '../components/SymptomLocationFrontFace'
import SymptomLocationFrontBody from '../components/SymptomLocationFrontBody'
import SymptomLocationBackBody from '../components/SymptomLocationBackBody'
import Bodyparts from '../components/Bodyparts'

export default observer({
  name: 'Summary',
  data() {
    return {
      store: store,
      patientInformationCollapsed: true,
      symptomsCollapsed: true,
      sadnessCollapsed: false,
      panicAttacksCollapsed: false,
      pregnancyCollapsed: false,
      takingMedicineCollapsed: false,
      painCollapsed: false,
      breathingProblemsCollapsed: false,
      problemsOfDigestionCollapsed: false,
      raisedBodyTemperatureCollapsed: false,
      dizzinessCollapsed: false,
      weaknessOrExhaustionCollapsed: false,
      rashItchRednessCollapsed: false,
      paralysisDeafnessPrickleCollapsed: false,
      sensoryPerceptionCollapsed: false,
      gynecologicalIssuesCollapsed: false,
      swellingCollapsed: false,
      childrensDiseaseCollapsed: false,
      medicalHistoryCollapsed: this.printView,
      edit: ''
    }
  },
  props: {
    printView: Boolean
  },
  components: {
    SectionHeader, 
    Dropdown, 
    YesNo, 
    NumberInput, 
    Button, 
    BreathingProblems,
    Pain,
    Pregnancy,
    WeaknessOrExhaustion,
    ParalysisDeafnessPrickle,
    SensoryPerception,
    ProblemsOfDigestion,
    RaisedBodyTemperature,
    Dizziness,
    Swelling,
    RashItchRedness,
    GynecologicalIssues,
    Symptoms,
    PatientInformation,
    MedicalHistory,
    SymptomLocationSideFace,
    SymptomLocationFrontFace,
    SymptomLocationFrontBody,
    SymptomLocationBackBody,
    Bodyparts
  },
  created() {
    this.store.persistBasicInformation()
    this.store.persistSymptoms()
    this.store.persistAdditionalConditions()
    this.store.persistAdditionalConditionDetails()
    this.store.persistSymptomDetails()
    this.store.persistMedicalHistory()
    this.store.persistSensoryPerceptionDetails()
    this.store.persistParalysisDeafnessPrickleDetails()
  },
  computed: {
    formatedSubstanceConsume() {
      let germanString = ''
      let translationString = ''
      this.store.medicalHistory.substanceConsume.forEach(substance => {
        const germanSubstanceName = this.$t(substance, 'de')
        const translatedSubstanceName = this.$t(substance)
        germanString === '' ? germanString = germanSubstanceName : germanString = germanString + ', ' + germanSubstanceName
        translationString === '' ? translationString = translatedSubstanceName : translationString = translationString + ', ' + translatedSubstanceName
      })
      return [germanString, translationString]
    }
  },
  methods: {
    currentCollapse: function(section) {
      const propName = section+'Collapsed'
      if (this[propName] !== undefined && this[propName] !== null) {
        return this[propName]
      } else return false
    },
    saveAndExport: function() {
      this.$router.push(`/${this.$i18n.locale}/nettdoctor/saveandexport`)
    },
    collapseSection: function(section) {
      if (section === 'patientInformation') {
        this.patientInformationCollapsed = !this.patientInformationCollapsed
        return
      }
      if (section === 'symptoms') {
        this.symptomsCollapsed = !this.symptomsCollapsed
        return
      }
      if (section === 'medicalHistory') {
        this.medicalHistoryCollapsed = !this.medicalHistoryCollapsed
        return
      }
      const name = section+'Collapsed'
      if (this[name] !== undefined && this[name] !== null) {
        this[name] = !this[name]
      }
    },
    editSection: function(section) {
      this.edit = section
    },
    closeEdit: function() {
      this.edit = ''
      this.store.persistSymptoms()
    },
    getImg: function(symptom) {
      let img = ''
      switch (symptom) {
        case 'sadness':
          img = 'sad'
          break;
        case 'panicAttacks':
          img = 'panic'
          break;
        case 'pregnancy':
          img = 'pregnant'
          break;
        case 'pain':
          img = 'illu-card-beschwerden-pain'
          break;
        case 'breathingProblems':
          img = 'illu-card-beschwerden-breath'
          break;
        case 'problemsOfDigestion':
          img = 'illu-card-beschwerden-digestion'
          break;
        case 'raisedBodyTemperature':
          img = 'illu-card-beschwerden-fever'
          break;
        case 'dizziness':
          img = 'illu-card-beschwerden-dizzy'
          break;
        case 'weaknessOrExhaustion':
          img = 'illu-card-beschwerden-exhausting'
          break;
        case 'rashItchRedness':
          img = 'illu-card-beschwerden-rash'
          break;
        case 'paralysisDeafnessPrickle':
          img = 'illu-card-beschwerden-paralysis'
          break;
        case 'sensoryPerception':
          img = 'illu-card-beschwerden-sensory-perception'
          break;
        case 'gynecologicalIssues':
          img = 'illu-card-beschwerden-gynecological'
          break;
        case 'swelling':
          img = 'illu-card-beschwerden-swelling'
          break;
        case 'childrensDisease':
          img = 'illu-card-beschwerden-children'
          break;
        default:
          break;
      }
      return img
    }
  }
})
</script>

<style lang="scss" scoped>
p {
  margin: unset;
  line-height: normal;
}
.nettdoc-summary {
  position: absolute;
  width: 100%;
  background-color: #ffffff;
  &__header {
    margin: 10px 0;
  }
  h2 {
    font-size: 26px;
    font-weight: 500;
  }
  &__double {
    display: grid;
    grid-template-columns: 50% 50%;
  }
  &__entry {
    position: relative;
    padding: 10px 16px;
    &--label {
      text-transform: uppercase;
      color: var(--cool-grey);
      font-weight: bold;
      font-size: 12px;
      & span {
        font-weight: normal;
      }
    }
    &--data {
      position: relative;
      box-sizing: border-box;
      border: unset;
      border-bottom: 1px solid #cacaca;
      width: 100%;
      padding: 10px 0 2px 0;
      font-weight: bold;
      font-size: 16px;
      color: var(--charcoal-grey);
      span {
        font-weight: normal;
        margin-left: 5px;
      }
    }
  }



  &__double-input {
    display: grid;
    grid-template-columns: 50% 50%;
    &__text {
      position: relative;
      padding: 10px;
      &__toplabel {
        text-transform: uppercase;
        color: #2c3e50;
        font-weight: bold;
        font-size: 12px;
        padding-left: 10px;
        & span {
          color: var(--cool-grey);
        }
      }
      &__input {
        position: relative;
      }
      input {
        box-sizing: border-box;
        border: unset;
        border-bottom: 1px solid #cacaca;
        width: 100%;
        padding: 10px;
        font-weight: 700;
        font-size: 16px;
        &::placeholder {
          color: var(--cool-grey);
        }
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }
      }
      &__input-delete {
        width: 12px;
        height: 12px;
        position: absolute;
        cursor: pointer;
      }
    }
  }
}
</style>